import ActionTypes from '@/actions/ActionTypes';

export type Country = {
  id: string;
  name: string;
  // Nullable on `location_type='region'` rows (src/schema.graphql); populated
  // only on real countries.
  country_iso2_code?: string | null;
};

export default function countriesReducer(
  state = [],
  action: { type: string; countries: Country[] }
) {
  switch (action.type) {
    case ActionTypes.COUNTRIES__FETCH_SUCCESS:
      return action.countries;
    default:
      return state;
  }
}
